import { BodyText } from '@block-explorer/ui';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';
import React from 'react';
import { Deploy } from '@block-explorer/entities';
import { ContractIdentifier } from '../../contract-identifier/contract-identifier';
import { useGetContractInfo } from '../../../hooks/event-store-hooks';
import { deriveSplitDataFromNamedKeyValue } from '../../../domain';
import { isWASMProxyTransaction } from '../../../utils/contract';
import { WasmProxyBadge } from '../wasm-proxy-badge';

export const CsprFunActionMessage = ({
  deploy,
}: {
  deploy: Deploy;
  hideContractIdentifier?: boolean;
}) => {
  const contractHash = deploy.args.token_to_trade_contract_hash_key?.parsed;
  const { hash } = deriveSplitDataFromNamedKeyValue(contractHash as string);

  // TODO: DERIVE
  const { data: contractPackageData } = useGetContractInfo({
    contract_hash: hash || '',
    includes: 'contract_package',
  });

  const contractPackageInfo = contractPackageData?.data?.contract_package;

  return (
    <FlexColumn>
      <FlexRow align={'baseline'} itemsSpacing={4}>
        {isWASMProxyTransaction(deploy.executionTypeId) && <WasmProxyBadge />}
        <FlexRow align={'baseline'} itemsSpacing={4}>
          <FlexRow itemsSpacing={6} align={'baseline'}>
            <BodyText monotype size={3} wordBreak noWrap>
              CSPR.fun trade
            </BodyText>
          </FlexRow>
        </FlexRow>
      </FlexRow>
      <FlexRow itemsSpacing={4}>
        <BodyText variation={'darkGray'} size={3}>
          with
        </BodyText>
        <ContractIdentifier
          hash={contractPackageData?.data?.contract_package_hash}
          contractPackage={contractPackageInfo}
          hideContractIdentifier={false}
        />
      </FlexRow>
    </FlexColumn>
  );
};
